(function () {
  let __osScrollY = 0;

  function openMenu() {
    const p = document.getElementById("os-dior-menu");
    if (!p) return;
    p.classList.add("is-open");
    lockScroll();
  }

  function closeMenu() {
    const p = document.getElementById("os-dior-menu");
    if (!p) return;
    p.classList.remove("is-open");
    unlockScroll();
  }

  function lockScroll() {
    __osScrollY = window.scrollY || 0;
    document.documentElement.classList.add("os-menu-open");
    document.body.classList.add("os-menu-open");
    document.body.style.top = `-${__osScrollY}px`;
  }

  function unlockScroll() {
    document.documentElement.classList.remove("os-menu-open");
    document.body.classList.remove("os-menu-open");
    const y = Math.abs(parseInt(document.body.style.top || "0", 10)) || __osScrollY;
    document.body.style.top = "";
    window.scrollTo(0, y);
  }

  function shouldOpenFromHamburger(e) {
    return (
      e.target.closest('button[aria-label="Menu"]') ||
      e.target.closest('summary[aria-label="Menu"]') ||
      e.target.closest(".header__icon--menu") ||
      e.target.closest(".header__icon--summary")
    );
  }

  function resetHamburgerState(el) {
    const details = el.closest("details");
    if (details) details.removeAttribute("open");
    if (el.matches("button, summary")) el.setAttribute("aria-expanded", "false");
  }

  function openFromHamburger(e) {
    const trig = shouldOpenFromHamburger(e);
    if (!trig) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    resetHamburgerState(trig);
    openMenu();
  }

  // Fermer si clic sur overlay / bouton X (dans ton HTML)
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-os-menu-close]")) closeMenu();
  });

  // Ouvrir via hamburger (avant Shopify)
  document.addEventListener("pointerdown", openFromHamburger, true);
  document.addEventListener("click", openFromHamburger, true);

  // Fermer avec ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeMenu();
  });
})();